import { transformForSubmit } from 'platform/forms-system/src/js/helpers';
import recordEvent from 'platform/monitoring/record-event';
import { apiRequest } from 'platform/utilities/api';

const submitFormFor = eventName =>
  function submitForm(form, formConfig, { mode } = {}) {
    const body = formConfig.transformForSubmit
      ? formConfig.transformForSubmit(formConfig, form)
      : transformForSubmit(formConfig, form);

    // Reject promise timer set to 30 seconds; except while testing
    const rejectTime = mode === 'testing' ? 1 : 3e4;

    const submitPromise = apiRequest(formConfig.submitUrl, {
      method: 'POST',
      body,
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(results => {
        recordEvent({ event: `${eventName}--submission-successful` });
        return results;
      })
      .catch(respOrError => {
        if (respOrError instanceof Error) {
          throw respOrError;
        }

        const status = respOrError?.errors?.[0]?.status;
        let error;
        if (status === '429') {
          error = new Error(`vets_throttled_error: ${status}`);
        } else {
          error = new Error(`vets_server_error: ${status || 'Unknown'}`);
        }
        throw error;
      });

    let timeoutId;
    const timeoutPromise = new Promise((_, reject) => {
      timeoutId = setTimeout(() => {
        recordEvent({ event: `${eventName}--submission-taking-too-long` });
        reject(new Error('client_error: Request taking too long'));
      }, rejectTime);
    });

    return Promise.race([submitPromise, timeoutPromise]).finally(() => {
      clearTimeout(timeoutId);
    });
  };

export default submitFormFor;
